var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.9941 25.6806C48.9941 17.5758 42.4007 10.9824 34.2959 10.9824C26.191 10.9824 19.5977 17.5758 19.5977 25.6806C19.5977 33.7855 26.191 40.3788 34.2959 40.3788C42.4007 40.3788 48.9941 33.7855 48.9941 25.6806ZM29.3965 34.2546H24.4971C23.8197 34.2546 23.2722 33.7071 23.2722 33.0297V20.7812C23.2722 20.1039 23.8197 19.5564 24.4971 19.5564H29.3965C29.9195 19.5564 30.358 19.8871 30.5343 20.3476C31.3648 19.4804 31.8462 18.3083 31.8462 17.1067C31.8462 15.0808 33.4948 13.4321 35.5207 13.4321C37.5466 13.4321 39.1953 15.0808 39.1953 17.1067V19.5564H41.645C43.6709 19.5564 45.3195 21.205 45.3195 23.2309V29.3552C45.3195 31.3811 43.6709 33.0297 41.645 33.0297H30.6213C30.6213 33.7071 30.0738 34.2546 29.3965 34.2546Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.8696 29.3552V23.2309C42.8696 22.5548 42.3209 22.0061 41.6447 22.0061H37.9702C37.2929 22.0061 36.7453 21.4586 36.7453 20.7812V17.1067C36.7453 16.4306 36.1966 15.8818 35.5205 15.8818C34.8444 15.8818 34.2956 16.4306 34.2956 17.1067C34.2956 18.9856 33.5338 20.8253 32.2048 22.1543L30.6211 23.738V30.58H41.6447C42.3209 30.58 42.8696 30.0313 42.8696 29.3552Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.1714 22.0059H25.7217V31.8047H28.1714V22.0059Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M63.6924 21.2441V27.6673L67.8214 24.4557L63.6924 21.2441Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.9297 1.20556C35.8609 -0.401445 32.7327 -0.40267 30.6602 1.20678L27.5405 3.63321H41.0519L37.9297 1.20556Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.89948 21.2441L0.770508 24.4557L4.89948 27.6673V21.2441Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 26.9604V69.72L27.4869 48.3402L0 26.9604Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.0789 46.813L61.2425 29.5732V6.08301H7.34912V29.5732L29.5128 46.813C32.3189 44.8728 36.2752 44.874 39.0789 46.813ZM17.1479 25.6806C17.1479 16.2248 24.84 8.53271 34.2958 8.53271C43.7517 8.53271 51.4437 16.2248 51.4437 25.6806C51.4437 35.1365 43.7517 42.8285 34.2958 42.8285C24.84 42.8285 17.1479 35.1365 17.1479 25.6806Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.6603 48.9758L2.34424 70.9998H66.2459L37.9298 48.9745C35.8598 47.3663 32.7328 47.3651 30.6603 48.9758Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.105 48.3402L68.5919 69.72V26.9604L41.105 48.3402Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceIcon);
export default __webpack_public_path__ + "static/media/referenceIcon.eb3d177071c6b9f433333d5e61472729.svg";
export { ForwardRef as ReactComponent };